/* Copyright (c) 2020-present CloudIO Inc */

import {
  CommonProps,
  defaultCommonProps,
} from '../../layout/Sidebar/panels/PropertiesView/CommonProperties';
import {
  BaseComponentItem,
  ExpressionValue,
} from '../../registry/Component.type';

export interface ChatBotItem extends BaseComponentItem {
  props: ChatBot;
  type: 'ChatBot';
}

export interface ChatBot extends CommonProps {
  // dsalias: string;
  botName: string;
  welcomeMessage: ExpressionValue;
  askAPI: string;
  wfId: string;
  confidenceThreshold: number;
}

export const defaultValue: Required<ChatBot> = {
  ...defaultCommonProps,
  botName: 'Chatbot',
  welcomeMessage: { value: '', type: 'text' },
  askAPI: '',
  wfId: '',
  confidenceThreshold: 0.5,
  // dsalias: '',
};
